import { render, staticRenderFns } from "./WorkstationProfilesOn.vue?vue&type=template&id=6098653e"
import script from "./WorkstationProfilesOn.vue?vue&type=script&lang=js"
export * from "./WorkstationProfilesOn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports